<template>
    <!-- 雇主险电动车统计 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">雇主险电动车统计</div> -->
        <div style="height:auto;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <!-- <el-col :span="6">
                        <div style="display:inline-block">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:300px"
                                collapse-tags :props="props"></el-cascader>
                        </div>
                    </el-col> -->
                    <el-col :span="4">
                        <span>时间</span>
                        <el-date-picker v-model="condition.years_date" type="month" placeholder="请选择" :clearable="false"
                            value-format="yyyy-MM" style="margin-left: 10px;width: 70%;">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="3">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Update">
                            更新</el-button>
                    </el-col>
                    <el-col :span="2">
                        <download-excel class="export-excel-wrapper" :fields="download_excel" name="雇主险电动车统计报表"
                            :fetch="ExportForm" style="top:100px;width:5%">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                导出</el-button>
                        </download-excel>
                    </el-col>
                </el-row>
            </div>

            <div style="margin: 10px 3% 0px;overflow-y:hidden;overflow-x: auto;">
                <div style="border:1px solid #ccc;width: 39%;height: 370px;float: left;">
                    <div style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                        <img src="../../../src/assets/小绿条.png" style="width: 4px; height: 20px;margin-right: 8px;" />
                        <span>雇主险/其他险结案情况统计表</span>
                    </div>

                    <div style="width: auto;height: 370px;" id="main1">
                    </div>
                </div>
                <div style="border:1px solid #ccc;width: 29.3%;height: 370px;float: left;margin: 0 1%;">
                    <div style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                        <img src="../../../src/assets/小绿条.png" style="width: 4px; height: 20px;margin-right: 8px;" />
                        <span>雇主险/其他险出险率</span>
                    </div>

                    <div style="width: auto;height: 370px;" id="main2">
                    </div>
                </div>
                <div style="border:1px solid #ccc;width: 29.3%;height: 370px;float: right;">
                    <div style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                        <img src="../../../src/assets/小绿条.png" style="width: 4px; height: 20px;margin-right: 8px;" />
                        <span>雇主险/其他险结案率</span>
                    </div>

                    <div style="width: auto;height: 370px;" id="main3">
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:30px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column prop="years_date" align="center" label="月份"></el-table-column>
                        <el-table-column prop="open_case_employer" align="center" label="期初末结案件">
                            <el-table-column prop="open_case_employer" align="center" label="雇主险"></el-table-column>
                            <el-table-column prop="open_case_other" align="center" label="其他险"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="open_case_other" align="center" label="当月新增">
                            <el-table-column prop="newly_added_employer" align="center" label="雇主险"></el-table-column>
                            <el-table-column prop="newly_added_other" align="center" label="其他险"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="newly_added_employer" align="center" label="当月结案">
                            <el-table-column prop="close_case_employer" align="center" label="雇主险"></el-table-column>
                            <el-table-column prop="close_case_other" align="center" label="其他险"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="newly_added_other" align="center" label="出险率">
                            <el-table-column prop="accident_rate_employer" align="center" label="雇主险"></el-table-column>
                            <el-table-column prop="accident_rate_other" align="center" label="其他险"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="close_case_employer" align="center" label="结案率">
                            <el-table-column prop="closing_rate_employer" align="center" label="雇主险"></el-table-column>
                            <el-table-column prop="closing_rate_other" align="center" label="其他险"></el-table-column>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            tableDatas: [],

            //复选框ids
            ids: [],

            //页面相关
            dialogVisible: false,
            //组织架构数据
            organizeList: [],
            //条件
            condition: {
                years_date: this.$globals.getNowTimes(),
                organize_ids: []
            },

            download_excel: {
                "月份": "years_date",
                "期初末结案件 - 雇主险": "open_case_employer",
                "期初末结案件 - 其他险": "open_case_other",
                "当月新增 - 雇主险": "newly_added_employer",
                "当月新增 - 其他险": "newly_added_other",
                "当月结案 - 雇主险": "close_case_employer",
                "当月结案 - 其他险": "close_case_other",
                "出险率 - 雇主险": "accident_rate_employer",
                "出险率 - 其他险": "accident_rate_other",
                "结案率 - 雇主险": "closing_rate_employer",
                "结案率 - 其他险": "closing_rate_other",
            },
            chart: {},
            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: true,
            },
        }
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },

        //图表
        async Find_Tu() {
            var url = "reportInsuranceStatistics/getReport";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.chart = data;
                    if (data == null) {
                        this.chart = {
                            newly_added_employer: "",
                            close_case_employer: "",
                            newly_added_other: "",
                            close_case_other: "",
                            accident_rate_employer: "",
                            accident_rate_other: "",
                            closing_rate_employer: "",
                            closing_rate_other: ""
                        }
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }

            echarts.init(document.getElementById('main1')).setOption({
                grid: {
                    top: '70px',
                    left: '70px',
                    right: '40px',
                    bottom: '80px'
                },
                legend: { left: 35, top: 20 },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: 'none'
                    }
                },
                dataset: {
                    dimensions: ['product', '雇主险', '其他险'],
                    source: [
                        // { product: '期初未结案件', 雇主险: this.chart.open_case_employer, 其他险: this.chart.open_case_other },
                        { product: '新增案件', 雇主险: this.chart.newly_added_employer, 其他险: this.chart.newly_added_other },
                        { product: '已结案件', 雇主险: this.chart.close_case_employer, 其他险: this.chart.close_case_other }
                    ]
                },
                xAxis: { type: 'category' },
                yAxis: {},
                series: [{ type: 'bar', barWidth: '15%', color: '#008E60' }, { type: 'bar', barWidth: '15%', color: '#FFA53C' }]
            })
            echarts.init(document.getElementById('main2')).setOption({
                grid: {
                    top: '50px',
                    left: '30px',
                    right: '40px',
                    bottom: '80px'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',//设置图例的方向
                    right: 40,
                    top: 120,
                    itemGap: 30,//设置图例的间距
                    textStyle: {
                        //图例字体大小
                        fontSize: 18,
                    },
                },
                color: ['#3B8CF8', '#31C78A'],
                series: [{
                    data: [
                        { value: this.chart.accident_rate_employer, name: '雇主险' },
                        { value: this.chart.accident_rate_other, name: '其他险' }
                    ],
                    type: 'pie',
                    radius: ['35%', '60%'],
                    label: {
                        show: false,
                        position: 'center'
                    },
                    center: ['35%', '45%'],
                }]
            })
            echarts.init(document.getElementById('main3')).setOption({
                grid: {
                    top: '50px',
                    left: '70px',
                    right: '40px',
                    bottom: '0px'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',//设置图例的方向
                    right: 40,
                    top: 120,
                    itemGap: 30,//设置图例的间距
                    textStyle: {
                        //图例字体大小
                        fontSize: 18,
                    },
                },
                color: ['#3B8CF8', '#31C78A'],
                series: [{
                    data: [
                        { value: this.chart.closing_rate_employer, name: '雇主险' },
                        { value: this.chart.closing_rate_other, name: '其他险' }
                    ],
                    type: 'pie',
                    radius: ['35%', '60%'],
                    label: {
                        show: false,
                        position: 'center'
                    },
                    center: ['35%', '45%'],
                }]
            })

        },
        //查询
        async Find() {
            this.Find_Tu();
            var url = "reportInsuranceStatistics/selectReportInsuranceStatistics";
            var record = {
                page_num: this.page_num,
                page_size: this.page_size,
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },

        async Update() {
            var url = "reportInsuranceStatistics/refreshReportInsuranceStatistics";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                if (code === '200') {
                    this.tableData = [];
                    this.page_num = 1;
                    this.page_size = 10;
                    this.total = 0;
                    this.$message.success("更新成功");
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //导表
        async ExportForm() {
            var url = "reportInsuranceStatistics/selectReportInsuranceStatistics";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableDatas = data.list;
                    this.total = data.total;
                    if (this.tableDatas.length > 0) {
                        this.$message.success("导表成功！文件下载中！");
                        return this.tableDatas;
                    } else {
                        this.$message.success("没有可以导出的数据！");
                        return null;
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
            });
            this.organizeList = this.getTreeData(organizeList.data);

        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        }
    },
    created() {
        this.Find();
        this.organizeFind();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// employer_insurance_statistical.vue?bae63b62